// actions.js
import * as actionKeys from './action-keys';
import { updateAction } from './utility';
import * as dot from 'dot-object';

export const setResources = (resources) => {
    return updateAction(actionKeys.SET_RESOURCES, dot.object(resources));
};

export const setInitialState = (initalState) => {
    return updateAction(actionKeys.SET_INITIAL_STATE, initalState);
};

export const setUiStatus = (uiStatus) => {
    return updateAction(actionKeys.SET_UI_STATUS, uiStatus);
};

export const setDisplayError = (displayError) => {
    return updateAction(actionKeys.SET_DISPLAY_ERROR, displayError);
};

export const setFormStep = (formStep) => {
    return updateAction(actionKeys.SET_FORM_STEP, formStep);
};

export const setIsSubmitting = (isSubmitting) => {
    return updateAction(actionKeys.SET_IS_SUBMITTING, isSubmitting);
};

export const setErrorText = (errorText) => {
    return updateAction(actionKeys.SET_ERROR_TEXT, errorText);
};

export const setSubmitEndpoint = (endpoint) => {
    return updateAction(actionKeys.SET_SUBMIT_ENDPOINT, endpoint);
};

export const setReceiptEndpoint = (endpoint) => {
    return updateAction(actionKeys.SET_RECEIPT_ENDPOINT, endpoint);
};

export const setPostFormData = (data) => {
    return updateAction(actionKeys.SET_POST_FORM, data);
};

export const setOpenTimesEndpoint = (data) => {
    return updateAction(actionKeys.SET_OPEN_TIMES_ENDPOINT, data);
};

export const setOpeningTimes = (data) => {
    return updateAction(actionKeys.SET_OPENING_TIMES, data);
};

export const setFlow = (flow) => {
    return updateAction(actionKeys.SET_FLOW, flow);
};

export const setShowInsurancesAction = (shouldShowInsurances) => {
    return updateAction(actionKeys.SET_SHOW_INSURANCES, shouldShowInsurances);
};

export const setSubmitGenesysEndpoint = (endpoint) => {
    return updateAction(actionKeys.SET_SUBMIT_GENESYS_ENDPOINT, endpoint);
};

export const setSubmitInsuranceGuideEndpoint = (endpoint) => {
    return updateAction(actionKeys.SET_SUBMIT_INSURANCE_GUIDE_ENDPOINT, endpoint);
};

/**
 * @param {Array} insurances
 */
export const setInsurances = (insurances) => ({
    type: actionKeys.SET_INSURANCES,
    payload: insurances
});

/**
 * @param {any} insurance
 */
export const addInsurance = (insurance) => ({ type: actionKeys.ADD_INSURANCE, payload: insurance });

/**
 * @param {any} insurance
 */
export const removeInsurance = (insurance) => ({
    type: actionKeys.REMOVE_INSURANCE,
    payload: insurance
});

/**
 * @param {string} name
 */
export const setAdditionalInfoAction = (additionalInfo) => ({
    type: actionKeys.SET_ADDITIONAL_INFO,
    payload: additionalInfo
});

/**
 * @param {string} name
 */
export const setNameAction = (name) => ({
    type: actionKeys.SET_NAME,
    payload: name
});

/**
 * @param {string} birthdate
 */
export const setBirthdateAction = (birthdate) => ({
    type: actionKeys.SET_BIRTHDATE,
    payload: birthdate
});

/**
 * @param {string} address
 */
export const setAddress = (address) => ({
    type: actionKeys.SET_ADDRESS,
    payload: address
});

/**
 * @param {boolean} isValid
 */
export const setIsAddressValid = (isValid) => ({
    type: actionKeys.SET_ADDRESS_VALID,
    payload: isValid
});

/**
 * @param {string} mobile
 */
export const setMobileAction = (mobile) => {
    let value = mobile.replace(/[A-Za-z!@#$%^&*()]/g, '');
    return {
        type: actionKeys.SET_MOBILE,
        payload: value
    };
};

/**
 * @param {string} email
 */
export const setEmailAction = (email) => ({
    type: actionKeys.SET_EMAIL,
    payload: email
});

/**
 * @param {string} contactOption
 */
export const setContactOption = (contactOption) => ({
    type: actionKeys.SET_CONTACT_OPTION,
    payload: contactOption
});

/**
 * @param {string} contactDateTimeOption
 */
export const setContactDateTimeOption = (contactDateTimeOption) => ({
    type: actionKeys.SET_CONTACT_DATE_TIME_OPTION,
    payload: contactDateTimeOption
});

/**
 * @param {string} contactDate
 */
export const setContactDateAction = (contactDate) => ({
    type: actionKeys.SET_CONTACT_DATE,
    payload: contactDate
});

/**
 * @param {string} contactTime
 */
export const setContactTimeAction = (contactTime) => ({
    type: actionKeys.SET_CONTACT_TIME,
    payload: contactTime
});

/**
 * @param {boolean} minimal
 */
export const setMinimal = (minimal) => ({
    type: actionKeys.SET_MINIMAL,
    payload: minimal
});
